//#region Import Required Libraries

import { InlineClickAction } from "./inline_click_action";
import { MESSAGE_LAYOUT, MESSAGE_STRUCTURE_TYPE } from "../enums";
import { MessageStructureComponent } from ".";
import { SenderDisplaySettingsConfig } from "./sender_display";

//#endregion

//#region MessageContent Interface

export type MessageContent = {
    layout?: MESSAGE_LAYOUT,
    structures?: MessageStructure[],
    quickReplies?: MessageStructureComponent[],
    metadata?: any,
    keys?: any,
    status?: string,
    messageTime?: string,
    typingIndicator?: {
        displayType: string
        displayValue: string
        timeout: number
    },
    processingIndicator?: {
        displayType: string
        timeout: number
        displayIcon?: string
        displayText?: string
    },
    settings?: MessageContentSettings,
    recordInfo?: {
        messageDateTime: Date
        messageCacheId: string,
        senderType: string,
        extMsgId: string,
        messageTimestamp: number,
    },
    type?: string,
}

//#endregion

//#region MessageStructure Interface

export type MessageStructure = {
    type: MESSAGE_STRUCTURE_TYPE;
    components: MessageStructureComponent[];
    showModal?: boolean;
    settings?: {
        hideButtonsOnSend?: boolean,
        hideNavigationImageOnSend: boolean
    };
    inlineClickActions?: Record<string, InlineClickAction>;
    __key: string;
}

//#endregion

//#region Multi Language Form Labels Types

// Define the keys for different forms
export type FormKey = "feedback_form" | "send_transcript_form" | "language_selector" | "info_button";

// Define the structure for localized strings and form labels
export type LocalizedStrings = Record<string, string | string[]>;
export type FormLabels = Partial<Record<FormKey, LocalizedStrings>>;

//#endregion

//#region MessageContentSettings Interface

export type MessageContentSettings = {
    hideInputContainer?: boolean;
    inputHidden?: boolean;
    hideInputContainerAlways?: boolean;
    hideQuickRepliesOnSend?: boolean;
    showOneQuickReplyPerLine?: boolean;
    clearScreen?: boolean;
    iframeBackButtonLabel?: string;
    taglineText?: string;
    messageTimeFormat?: string;
    sendingIndicatorText?: string;
    inputContainerPlaceholderText?: string,
    feedback?: {
        enableComment?: boolean;
        enableRating?: boolean;
    };
    languageCode?: string;
    formLabels?: FormLabels;
    scrollPosition?: ScrollPosition;
    senderDisplaySettings?: SenderDisplaySettingsConfig;
};

export type ScrollPosition = "top" | "near_top" | "default";

//#endregion
